export const IS_FORM_DIRTY = 'IS_FORM_DIRTY';
export const SHOW_CHICKEN_EXIT = 'SHOW_CHICKEN_EXIT';

export function setIsFormDirty(isDirty) {
  return {
    type: IS_FORM_DIRTY,
    payload: isDirty,
  };
}

export function setShowChickenExit(showChickenExit) {
  return {
    type: SHOW_CHICKEN_EXIT,
    payload: showChickenExit,
  };
}
